import styled from '@emotion/styled'
import { css } from '@emotion/react'
import {Typography} from 'src/components/atoms/Typography'

const Tag = styled(Typography)`
  display: inline-block;
  color: white;
  background: ${({ isHighlight }) => (isHighlight ? '#22475d' : '#ccc')};
  text-align: center;
  border-radius: 25px;
  ${({ small }) => (small ? smallCss : normalCss)}
`

const normalCss = css`
  min-width: 100px;
  padding: 10px 20px;
  font-size: 0.85rem;
`

const smallCss = css`
  padding: 5px 10px;
  font-size: 0.75rem;
`

export default Tag
